// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7a071f30","796":"57f7f407"}[chunkId] + ".chunk.js";
};